"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef } from "react";
export default function Hero() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const parallaxRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (parallaxRef.current) {
        const scrollY = window.scrollY;
        parallaxRef.current.style.transform = `translateY(${scrollY * 0.4}px)`;
      }
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section className="relative w-full h-screen overflow-hidden bg-dark-background">
      {}
      <div ref={parallaxRef} className="absolute inset-0 w-full h-[120%] bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1522495/img/hero_lagos_skyline_property.png)]" style={{
      willChange: "transform"
    }} />

      {}
      <div className="absolute inset-0 bg-dark-background/40" />

      {}
      <div ref={contentRef} className="relative z-10 flex flex-col items-center justify-center h-full px-4 text-center">
        <h1 className={`font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-foreground-dark mb-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          Your Unfair Advantage in
          <br />
          Nigerian Real Estate
        </h1>

        <p className={`font-sans text-lg sm:text-xl md:text-2xl text-foreground-dark/90 max-w-3xl mb-10 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
        transitionDelay: isVisible ? "100ms" : "0ms"
      }}>
          Combining real estate intelligence with cutting-edge SEO to deliver
          unmatched results for Nigerian investors and businesses
        </p>

        <div className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
        transitionDelay: isVisible ? "200ms" : "0ms"
      }}>
          <Link to="/ContactPage">
            <Button size="lg" className="bg-secondary text-foreground-secondary hover:bg-secondary-hover active:bg-secondary-active shadow-medium hover:shadow-strong hover:scale-[1.03] active:scale-100 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] px-8 py-6 text-base sm:text-lg font-semibold rounded-md">
              Get Started Today
            </Button>
          </Link>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-dark-background to-transparent" />
    </section>;
}